// SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

/// <reference types="./declarations" />
export const VERSION = '0.0.0';
export const SCOPE = '@nvidia-elements';
export { I18nService, getThemeTokens } from '@nvidia-elements/core/internal';
export * from './internal/types/index.js';
